module.exports = __webpack_public_path__ + "static/img/about-banner.62f7bf2.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/about-banner.jpg
// module id = OXHe
// module chunks = 1